












































































































































import EmployeeApportionment from '@/domain/employees/entity/employee-apportionment';
import EmployeeApportionmentService from '@/domain/employees/service/employee-apportionment.service';
import { VbSnackbarService } from 'bag-of-holding-library';
import {
  Vue,
  Component,
  Prop,
  Watch,
} from 'vue-property-decorator';
import LabelSlot from '@/shared/slots/label-slot.component.vue';
import ResultCenter from '@/domain/result-center/entity/result-center.entity';
import ResultCenterService from '@/domain/result-center/service/result-center.service';
import ResultCenterSelect from '@/shared/result-center/result-center-select.component.vue';
import ButtonIcon from '@/shared/buttons/button-icon.component.vue';
import ModalOptions from '@/shared/modal/modal-options.entity';
import EmployeeApportionmentRequest from '@/domain/employees/entity/employee-apportionment-request.entity';
import Loading from '@/shared/loading/loading.component.vue';

@Component({
  components: {
    LabelSlot,
    ResultCenterSelect,
    ButtonIcon,
    Loading,
  },
})
class EmployeeApportionmentComponent extends Vue {
  @Prop({
    type: String,
    default: '',
  }) employeeId!: string;

  @Prop({
    type: Boolean,
    default: false,
  }) hasUpdateEmployeeApportionment!: boolean;

  @Prop({
    type: Array,
    default: () => [],
  }) employeeApportionments!: EmployeeApportionment[];

  @Prop({
    type: String,
    default: '',
  }) mainResultCenter!: String;

  localEmployeeApportionments: EmployeeApportionment[] = [];

  resultCenters: ResultCenter[] = [];

  showConfirmDeleteModal: boolean = false;

  loadingDelete: boolean = false;

  loadingSave: boolean = false;

  isEditMode: boolean = false;

  showMainResultCenter: boolean = false;

  loading: boolean = false;

  get deleteModalWarningOptions(): ModalOptions {
    return {
      title: 'Atenção',
      description:
        'Você realmente deseja fazer esta ação? Ela não poderá ser desfeita.',
      showOk: true,
      disabledOk: false,
      labelOk: 'Sim, Excluir',
      okColor: 'error',
      loadingOk: this.loadingDelete,
      showCancel: !this.loadingDelete,
      labelCancel: 'Cancelar',
      width: 400,
    };
  }

  created() {
    this.getResultCenters();
    this.localEmployeeApportionments = [...(this.employeeApportionments || [])];
    this.setShowMainResultCenter();
  }

  @Watch('employeeApportionments', { immediate: true, deep: true })
  onEmployeeApportionmentsChanged(newVal: EmployeeApportionment[]) {
    if (this.isEditMode) return
    this.localEmployeeApportionments = [...(newVal || [])];
    this.setShowMainResultCenter();
  }

  setShowMainResultCenter() {
    this.showMainResultCenter = this.localEmployeeApportionments.length === 0 && !this.isEditMode;
  }

  setIsEditMode(newVal: boolean) {
    this.isEditMode = newVal;
    this.setShowMainResultCenter();
  }

  async getResultCenters() {
    try {
      this.loading = true;
      this.resultCenters = await ResultCenterService.getAllActiveResultCenters();
    } catch (error) {
      VbSnackbarService.handleHttpError(error);
    } finally {
      this.loading = false;
    }
  }

  updatePercentage(apportionment: EmployeeApportionment, value: number) {
    apportionment.percentage = value;
  }

  updateResultCenter(apportionment: EmployeeApportionment, value: ResultCenter) {
    apportionment.resultCenter = value;
  }

  handleDelete(apportionment: EmployeeApportionment) {
    const updated = this.localEmployeeApportionments.filter(
      item => item.tempId !== apportionment.tempId,
    );
    this.localEmployeeApportionments = [];
    this.$nextTick(() => {
      this.localEmployeeApportionments = updated;
    });
    apportionment.showDeleteModal = false;
  }

  addApportionment() {
    const newApportionment = new EmployeeApportionment();
    this.localEmployeeApportionments = [...this.localEmployeeApportionments, newApportionment];
  }

  async saveChanges() {
    try {
      this.loadingSave = true;

      if (this.hasApportionmentWithoutResultCenter()) {
        VbSnackbarService.showError('Existe rateio sem centro de custo informado.');
        return;
      }

      const body: EmployeeApportionmentRequest[] = this.employeeApportionmentsToRequest();

      const responseEmployeeApportionment = await EmployeeApportionmentService
        .saveEmployeeApportionment(
          this.employeeId,
          body,
        );

      this.$emit('update:employeeApportionments', responseEmployeeApportionment);
      this.$emit('saved');
      this.localEmployeeApportionments = [...responseEmployeeApportionment];
      this.setShowMainResultCenter();

      VbSnackbarService.showSuccess('Rateios salvos com sucesso.');
      this.setIsEditMode(false);
    } catch (error) {
      VbSnackbarService.handleHttpError(error);
    } finally {
      this.loadingSave = false;
    }
  }

  employeeApportionmentsToRequest(): EmployeeApportionmentRequest[] {
    return this.localEmployeeApportionments.map(apportionment => ({
      id: apportionment.id,
      resultCenterId: apportionment.resultCenter.id || '',
      percentage: Number(apportionment.percentage),
    }));
  }

  hasApportionmentWithoutResultCenter(): boolean {
    return this.localEmployeeApportionments.some(
      apportionment => !apportionment.resultCenter || !apportionment.resultCenter.id,
    );
  }

  resultCenterName(id : string) : string {
    const resultCenter = this.resultCenters.find(rc => rc.id === id);
    return resultCenter ? resultCenter.name : '';
  }

  async copyResultCenterDescription(resultCenterId: string) {
    try {
      const description = this.resultCenterName(resultCenterId);
      await navigator.clipboard.writeText(description);
      VbSnackbarService.showSuccess('Descrição copiada para a área de transferência!');
    } catch (e) {
      VbSnackbarService.showError('Não foi possível copiar a descrição.');
    }
  }


  get totalPercentage(): number {
    if (this.showMainResultCenter) {
      return 100;
    }

    const totalPercentage = this.localEmployeeApportionments
      .reduce((total, apportionment) => total + Number(apportionment.percentage), 0)
    return Number(totalPercentage.toFixed(2));
  }

  get totalPercentageIsValid(): boolean {
    return this.totalPercentage === 100;
  }
}
export default EmployeeApportionmentComponent;
